(() => {
  const formatMoney = (cents, format) => {
    if (window.theme?.utils?.formatMoney instanceof Function) {
      return window.theme.utils.formatMoney(cents, format);
    }
    if (window.Shopify?.formatMoney instanceof Function) {
      return window.Shopify.formatMoney(cents, format);
    }
    if (window.formatMoney instanceof Function) {
      return window.formatMoney(cents, format);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const parseJson = (node, fallback = []) => {
    try {
      return JSON.parse(node?.textContent || '') || fallback;
    } catch (error) {
      console.error('Unable to read Bolt Pro variant data.', error);
      return fallback;
    }
  };

  const setHidden = (element, hidden) => {
    if (!element) return;
    element.hidden = hidden;
  };

  const updateShipping = (card, variant, shippingRules) => {
    if (!card) return;

    const variantId = String(variant.id);
    const rule = shippingRules.find((item) => {
      return (item.variant_id && String(item.variant_id) === variantId)
        || (item.variant_sku && item.variant_sku.trim().toLowerCase() === (variant.sku || '').trim().toLowerCase());
    });
    const resolvedRule = rule || {
      status: card.dataset.defaultShippingStatus || '',
      copy: card.dataset.defaultShippingCopy || '',
      expected: card.dataset.defaultShippingExpected || '',
      fulfillment: card.dataset.defaultShippingFulfillment || '',
      cta: card.dataset.defaultShippingCta || 'Shop with a retailer',
      url: card.dataset.defaultShippingUrl || '',
    };

    card.dataset.shippingState = resolvedRule.fulfillment || '';
    const status = card.querySelector('[data-bp-shipping-status]');
    const copy = card.querySelector('[data-bp-shipping-copy]');
    const expected = card.querySelector('[data-bp-shipping-expected]');
    const link = card.querySelector('[data-bp-shipping-link]');
    if (status) status.textContent = resolvedRule.status || '';
    if (copy) copy.textContent = resolvedRule.copy || '';
    if (expected) {
      expected.textContent = resolvedRule.expected || '';
      setHidden(expected, !resolvedRule.expected);
    }
    if (link) {
      link.textContent = resolvedRule.cta || 'Shop with a retailer';
      if (resolvedRule.url) {
        link.href = resolvedRule.url;
        setHidden(link, false);
      } else {
        link.removeAttribute('href');
        setHidden(link, true);
      }
    }
  };

  const initializeVariants = (section) => {
    if (!section || section.dataset.bpVariantsInitialized === 'true') return;
    const picker = section.querySelector('[data-bp-variant-picker]');
    const variantsNode = section.querySelector('[data-bp-variants]');
    if (!picker || !variantsNode) return;

    const variants = parseJson(variantsNode);
    if (!variants.length) return;
    const shippingRules = parseJson(section.querySelector('[data-bp-shipping-variants]'));
    const shippingCard = section.querySelector('[data-bp-shipping-card]');
    const variantIdInput = section.querySelector('[data-bp-variant-id]');
    const moneyFormat = section.dataset.bpMoneyFormat || '${{amount}}';
    const regularPriceNodes = section.querySelectorAll('[data-bp-current-price], [data-bp-earlybird-regular-price]');
    const earlyBirdPriceNodes = section.querySelectorAll('[data-bp-earlybird-price]');
    const finishLabel = section.querySelector('[data-bp-finish-label]');
    const button = section.querySelector('[data-pro-earlybird-button]');
    const regularLabel = section.querySelector('[data-pro-regular-label]');
    const soldOutLabel = section.querySelector('[data-bp-sold-out-label]');
    const optionInputs = Array.from(picker.querySelectorAll('[data-bp-option-input]'));
    let currentVariantId = variantIdInput?.value ? String(variantIdInput.value) : '';

    const optionDisplayLabel = (value, position) => {
      const input = optionInputs.find((item) => Number(item.dataset.optionPosition) === position && item.value === value);
      return input?.dataset.bpOptionDisplayLabel || value || '';
    };

    const updateDisplayTitle = (variant) => {
      if (!variantIdInput) return;
      const hasDisplayLabel = optionInputs.some((input) => input.checked && input.dataset.bpOptionDisplayLabel);
      if (hasDisplayLabel) {
        variantIdInput.dataset.variantDisplayTitle = variant.options.map((value, index) => optionDisplayLabel(value, index + 1)).join(' / ');
      } else {
        delete variantIdInput.dataset.variantDisplayTitle;
      }
    };

    const reserveOptionLabelSpace = () => {
      if (!picker.classList.contains('bp-variant-picker--display-labels') || !section.isConnected) return;
      picker.querySelectorAll('[data-bp-option-current]').forEach((current) => {
        const label = current.closest('legend');
        const width = label.getBoundingClientRect().width;
        if (!width) return;
        const probe = label.cloneNode(true);
        probe.setAttribute('aria-hidden', 'true');
        probe.inert = true;
        Object.assign(probe.style, {
          position: 'absolute', visibility: 'hidden', pointerEvents: 'none',
          boxSizing: 'border-box', width: `${width}px`, minHeight: '0', height: 'auto', top: '0', left: '0',
        });
        picker.append(probe);
        let height = 0;
        optionInputs.filter((input) => input.dataset.optionPosition === current.dataset.optionPosition).forEach((input) => {
          probe.querySelector('[data-bp-option-current]').textContent = input.dataset.bpOptionDisplayLabel || input.value;
          height = Math.max(height, probe.getBoundingClientRect().height);
        });
        probe.remove();
        label.style.minHeight = `${Math.ceil(height)}px`;
      });
    };

    const reserveShippingSpace = () => {
      if (!shippingCard || !section.isConnected) return;
      const width = shippingCard.getBoundingClientRect().width;
      if (!width) return;

      // Measure every shipping state offscreen so a variant change cannot resize the hero.
      const probe = shippingCard.cloneNode(true);
      probe.removeAttribute('data-bp-shipping-card');
      probe.setAttribute('aria-hidden', 'true');
      probe.inert = true;
      Object.assign(probe.style, {
        position: 'absolute',
        visibility: 'hidden',
        pointerEvents: 'none',
        boxSizing: 'border-box',
        width: `${width}px`,
        minHeight: '0',
        height: 'auto',
        top: '0',
        left: '0',
      });
      section.append(probe);
      let height = 0;
      variants.forEach((variant) => {
        updateShipping(probe, variant, shippingRules);
        height = Math.max(height, probe.getBoundingClientRect().height);
      });
      probe.remove();
      shippingCard.style.minHeight = `${Math.ceil(height)}px`;
    };

    const selectedOptions = () => Array.from(picker.querySelectorAll('[data-bp-option-input]'))
      .filter((input) => input.checked)
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

    const findVariant = (options) => variants.find((variant) => {
      const variantOptions = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
      return variantOptions.length === options.length && variantOptions.every((value, index) => value === options[index]);
    });

    const updateOptionLabels = (variant) => {
      section.querySelectorAll('[data-bp-option-current]').forEach((label) => {
        const position = Number(label.dataset.optionPosition) - 1;
        label.textContent = optionDisplayLabel(variant.options?.[position], position + 1);
      });
    };

    const updateButton = (variant) => {
      if (!button) return;
      const available = Boolean(variant.available);
      const earlyBirdActive = section.dataset.proEarlybirdActive === 'true';
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
      setHidden(soldOutLabel, available);
      setHidden(regularLabel, !available || earlyBirdActive);
      setHidden(section.querySelector('[data-pro-earlybird-label]'), !available || !earlyBirdActive);
    };

    const updateVariant = (variant) => {
      if (!variant || String(variant.id) === currentVariantId) return;
      currentVariantId = String(variant.id);
      if (variantIdInput) {
        variantIdInput.value = variant.id;
        updateDisplayTitle(variant);
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const formattedPrice = formatMoney(variant.price, moneyFormat);
      const earlyBirdPrice = variant.price - Math.floor(variant.price * 15 / 100);
      const formattedEarlyBirdPrice = formatMoney(earlyBirdPrice, moneyFormat);
      regularPriceNodes.forEach((node) => { node.textContent = formattedPrice; });
      earlyBirdPriceNodes.forEach((node) => { node.textContent = formattedEarlyBirdPrice; });
      if (finishLabel) finishLabel.textContent = variantIdInput?.dataset.variantDisplayTitle || variant.title || '';
      updateOptionLabels(variant);
      updateButton(variant);
      updateShipping(shippingCard, variant, shippingRules);
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    };

    picker.addEventListener('change', (event) => {
      if (!event.target.matches('[data-bp-option-input]')) return;
      const variant = findVariant(selectedOptions());
      if (variant) updateVariant(variant);
    });
    section.addEventListener('pro:earlybird-change', () => {
      const variant = variants.find((item) => String(item.id) === currentVariantId);
      if (variant) updateButton(variant);
    });

    const initialVariant = variants.find((variant) => String(variant.id) === currentVariantId)
      || findVariant(selectedOptions())
      || variants.find((variant) => variant.available)
      || variants[0];
    if (initialVariant && variantIdInput && String(variantIdInput.value) !== String(initialVariant.id)) {
      variantIdInput.value = initialVariant.id;
    }
    if (initialVariant) {
      currentVariantId = String(initialVariant.id);
      updateDisplayTitle(initialVariant);
      updateOptionLabels(initialVariant);
      updateButton(initialVariant);
      updateShipping(shippingCard, initialVariant, shippingRules);
    }
    const reserveLayoutSpace = () => {
      reserveShippingSpace();
      reserveOptionLabelSpace();
    };
    const layoutWidths = () => `${picker.getBoundingClientRect().width}:${shippingCard?.getBoundingClientRect().width || 0}`;
    reserveLayoutSpace();
    if (window.ResizeObserver) {
      let measuredWidths = layoutWidths();
      const resizeObserver = new ResizeObserver(() => {
        const widths = layoutWidths();
        if (widths === measuredWidths) return;
        measuredWidths = widths;
        reserveLayoutSpace();
      });
      resizeObserver.observe(picker);
      if (shippingCard) resizeObserver.observe(shippingCard);
    }
    if (document.fonts) document.fonts.ready.then(reserveLayoutSpace);
    section.dataset.bpVariantsInitialized = 'true';
  };

  const initialize = (root = document) => {
    const sections = [];
    if (root.matches && root.matches('[data-bp-variant-picker]')) sections.push(root.closest('.bp--product'));
    if (root.matches && root.matches('.bp--product')) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('.bp--product'));
    sections.filter(Boolean).forEach(initializeVariants);

    root.querySelectorAll('[data-bp-tabs]').forEach((tabs) => {
      if (tabs.dataset.initialized === 'true') return;
      tabs.dataset.initialized = 'true';

      const section = tabs.closest('[data-bp-uses]');
      if (!section) return;
      const image = section.querySelector('[data-bp-use-image]');
      const source = section.querySelector('[data-bp-use-source]');
      const label = section.querySelector('[data-bp-use-label]');

      tabs.addEventListener('click', (event) => {
        const button = event.target.closest('[data-bp-tab]');
        if (!button || !tabs.contains(button)) return;

        tabs.querySelectorAll('[data-bp-tab]').forEach((tab) => {
          const selected = tab === button;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        if (image && button.dataset.image) {
          image.style.opacity = '.25';
          window.setTimeout(() => {
            if (source) source.srcset = button.dataset.imageMobile || button.dataset.image;
            image.src = button.dataset.image;
            image.alt = button.dataset.alt || '';
            section.style.setProperty('--bp-use-image-position', button.dataset.position || 'center center');
            section.style.setProperty('--bp-use-image-position-mobile', button.dataset.positionMobile || 'center center');
            image.style.opacity = '1';
          }, 140);
        }
        if (label) label.textContent = button.dataset.label || button.textContent.trim();
      });

      tabs.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(tabs.querySelectorAll('[data-bp-tab]'));
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        let next = current;
        if (event.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') next = (current + 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        buttons[next].focus();
        buttons[next].click();
      });
    });

    root.querySelectorAll('[data-bp-video-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';

      const section = dialog.closest('.bp--product');
      const opener = section && section.querySelector(`[aria-controls="${dialog.id}"]`);
      const closeButton = dialog.querySelector('[data-bp-video-close]');
      const hostedVideo = dialog.querySelector('video');
      const externalVideo = dialog.querySelector('[data-bp-video-embed]');
      const externalVideoSrc = externalVideo && externalVideo.src;
      let returnFocus = null;

      const stopVideo = () => {
        if (hostedVideo) hostedVideo.pause();
        if (externalVideo && externalVideoSrc) {
          externalVideo.src = 'about:blank';
          externalVideo.src = externalVideoSrc;
        }
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          stopVideo();
          if (returnFocus) returnFocus.focus();
          returnFocus = null;
        }
      };

      if (opener) {
        opener.addEventListener('click', () => {
          returnFocus = opener;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          window.requestAnimationFrame(() => closeButton && closeButton.focus());
        });
      }

      if (closeButton) closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', () => {
        stopVideo();
        if (returnFocus) returnFocus.focus();
        returnFocus = null;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
